<template>
  <div class="container">
    <el-tabs class="top-tab" v-model="activeType" type="card" @tab-click="tabChange">
      <el-tab-pane label="系统工具" name="system" />
      <el-tab-pane label="自定义工具" name="custom" />
    </el-tabs>
    <template v-if="showMap['system']">
      <div class="table-container" v-show="activeType === 'system'">
        <list :is-system="true"></list>
      </div>
    </template>
    <template v-if="showMap['custom']">
      <div class="table-container" v-show="activeType === 'custom'">
        <list :is-system="false"></list>
      </div>
    </template>
  </div>
</template>

<script>
import List from './components/list';
export default {
  data() {
    return {
      activeType: 'system',
      showMap: {
        system: true,
      },
    };
  },
  components:{ List },
  methods: {
    tabChange() {
      this.$nextTick(()=>{
        this.$set(this.showMap, this.activeType, true);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/tab.scss';
.container {
  display: flex;
  flex-direction: column;
}
.top-tab {
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 16px;
  padding-right: 16px;
}
.table-container {
  flex: 1;
  margin: 16px 0;
  padding: 16px;
  background: #fff;
}
</style>
